import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import PageHeader from 'components/common/general/layouts/PageHeader';
import { useOverrideUwRatesPageStore } from 'store/pages/override-uw-rates/pageStore';
import { Spinner } from '@insurancemenu/imenu-components-lib';
import PageFooter from 'components/common/general/layouts/PageFooter';
import { UnderwritingResultsSection } from './UnderwritingResultsSection';
import { OverrideRatesSection } from './OverrideRatesSection';
import { SpinnerWrapperStyled } from './styles';
import { OVERRIDE_RATES_LOADING_SPINNER_TEST_ID } from './constants';

export const OverwriteUwRatesContent: React.FC = observer(() => {
  const pageStore = useOverrideUwRatesPageStore();

  useEffect(() => {
    void pageStore.getInitialData();
  }, []);

  return (
    <>
      <PageHeader
        title="Overwrite Final Rates"
        subtitle="Adjust your final rates by applying a discount or manually updating the values before submission"
        subtitleMaxWidth="53rem"
        onRedirect={pageStore.onBackRedirect}
      />

      {pageStore.isLoading ? (
        <SpinnerWrapperStyled>
          <Spinner size="8rem" data-test-id={OVERRIDE_RATES_LOADING_SPINNER_TEST_ID} />
        </SpinnerWrapperStyled>
      ) : (
        <>
          <UnderwritingResultsSection />
          <OverrideRatesSection />
          <PageFooter
            onBack={pageStore.onBackRedirect}
            disableCompleteButton={!pageStore.canOverrideRates}
            onComplete={pageStore.overrideRates}
            completeButtonText="Override Rates"
          />
        </>
      )}
    </>
  );
});
